import { BaseApiService } from '@/_services/baseApi.service'

export class NotificationService extends BaseApiService {
  constructor () {
    super()
    this.baseUrl = `${process.env.VUE_APP_BASE_URL}/v1/`
  }

  getAllUnread (userId) {
    const url = this.baseUrl + `notification/user-interface/${userId}?status=UNREAD&limit=50&offset=0`
    return this.sendGetRequest(url)
  }

  getUserNotifications (userId, status, page) {
    const url = this.baseUrl + `notification/user/${userId}?status=${status}&page=${page}`
    return this.sendGetRequest(url)
  }

  setNotificationRead (param, notId, userId) {
    let url
    if (param === 'ALL') {
      url = this.baseUrl + `notification/make-all-read?userId=${userId}`
    } else {
      url = this.baseUrl + `notification/make-read?notificationId=${notId}`
    }
    return this.sendPostRequest(url)
  }
}
export default new NotificationService()
